export enum StepType {
  Entry = 0,
  Exit,
  Intermediate,
  AdHoc,
  SubWorkflowStep,
}
